import { gql } from "@apollo/client";

const GET_MY_CHAPTERS = gql`
  query MyChapters($levelId: ID) {
    myChapters(levelId: $levelId) {
      id
      name
      level {
        id
        title
      }
      percentage
      topics {
        id
        title
        cities {
          name
        }
        category {
          name
          skippedIfSpokenOnly
        }
        skipped
        beingBookedOn
        studied
        studiedCount
      }
    }
    me {
      currentLevel {
        id
      }
    }
  }
`;

export default GET_MY_CHAPTERS;
